<template>
  <div class="user_new">
    <span>{{ $t('meta_title.user.new') }}</span>

    <div class="user_form">
      <form @submit.prevent="post" method="post">
        <div class="form-group">
          <label for="user_firstname" class="required">{{ $t('object.user.firstname') }}</label>
          <input type="text" id="user_firstname" name="firstname" required class="form-control"
                 v-model="firstname">
        </div>
        <div class="form-group">
          <label for="user_lastname" class="required">{{ $t('object.user.lastname') }}</label>
          <input type="text" id="user_lastname" name="lastname" required class="form-control"
                 v-model="lastname">
        </div>
        <div class="form-group">
          <label for="user_email" class="required">{{ $t('object.user.email') }}</label>
          <input type="email" id="user_email" name="email" required class="form-control"
                 v-model="email">
        </div>

        <div class="form-group">
          <label for="user_password" class="required">{{ $t('object.security.password') }}</label>
          <input type="password" id="user_password" name="password" required class="form-control"
                 v-model="password">
        </div>

        <div class="form-group">
          <label for="user_confirm_password" class="required">{{ $t('object.security.confirm_password') }}</label>
          <input type="password" id="user_confirm_password" name="confirm_password" required class="form-control"
                 v-model="confirm_password">
        </div>

        <div class="form-group">
          <label class="required" for="role">{{ $t('object.user.role') }}</label>
          <select id="role" name="role" required class="form-control" v-model="role">
            <option v-for="role in roles" v-bind:value="role">{{ role }}</option>
          </select>
        </div>

        <input type="submit">
      </form>
    </div>
  </div>
</template>

<script>
  import toast from '@/toastr'

  export default {
    name: 'UserNew',
    data() {
      return {
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        confirm_password: '',
        role: '',
        roles: '',
      }
    },
    created(){

      // Get the list of available roles, considering the current user's role
      this.$http.get(`role`, {
        successHandle: false,
        redirectOnFailure: {name: 'Home'}
      }).then(response => {
        this.roles = response.data.roles
      })
    },
    methods: {
      post() {
        this.$http.post(`user`, {
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            password: this.password,
            confirm_password: this.confirm_password,
            role: this.role
          }, {
            redirectOnSuccess: {name: 'UserList'}
          }
        )
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/new.vue